/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationRequestDTO
 */
export interface AuthenticationRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    password?: string;
}

export function AuthenticationRequestDTOFromJSON(json: any): AuthenticationRequestDTO {
    return AuthenticationRequestDTOFromJSONTyped(json, false);
}

export function AuthenticationRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function AuthenticationRequestDTOToJSON(value?: AuthenticationRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

